import { UserProfile } from '@app/types'
import { useMemo } from 'react'

export const useAdminMetrics = (users: UserProfile[]) => {
  return useMemo(
    () => ({
      total: users.length,
      confirmed: users.filter((u) => u.status === 'CONFIRMED'),
      pending: users.filter((u) => u.status !== 'CONFIRMED'),
    }),
    [users],
  )
}
